import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexBreadcrumb',
  setup(__props) {

const DefaultBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/DefaultBreadcrumb.vue"))
const DividersBreadcrumbs = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/DividersBreadcrumbs.vue"))
const IconsBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/IconsBreadcrumb.vue"))
const NavBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/NavBreadcrumb.vue"))
const ColoredNavigation = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/ColoredNavigation.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DefaultBreadcrumb)),
      _createVNode(_unref(DividersBreadcrumbs)),
      _createVNode(_unref(IconsBreadcrumb)),
      _createVNode(_unref(NavBreadcrumb)),
      _createVNode(_unref(ColoredNavigation))
    ])
  ]))
}
}

})